// extracted by mini-css-extract-plugin
module.exports = {"loginView":"login_loginView__1HUu0","loginForm":"login_loginForm__1PM0p","title":"login_title__IBD1E","inputBox":"login_inputBox__14TkE","loginFormBtn":"login_loginFormBtn__OuyyE"};